import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface HoverTooltipProps {
    children: ReactNode;
    content: ReactNode;
    /** Custom className for tooltip positioning and arrow placement */
    tooltipClassName?: string;
    /** Group hover target - if provided, will use group-hover/{groupName}:opacity-100 */
    groupName?: string;
}

export const HoverTooltip = ({
    children,
    content,
    tooltipClassName,
    groupName
}: HoverTooltipProps) => {
    // Always use standard group-hover for better Tailwind compatibility
    const hoverClass = "group-hover:opacity-100";

    return (
        <>
            {children}
            <div
                className={cn(
                    // Base tooltip styles
                    `pointer-events-none absolute z-10 whitespace-nowrap
                    rounded-md bg-white px-3 py-1.5 text-xs text-black opacity-0
                    transition-opacity duration-200 ease-in-out`,
                    // Arrow styles using ::before pseudo-element
                    `before:absolute before:top-[-4px] before:h-0 before:w-0
                    before:border-b-[4px] before:border-l-[4px]
                    before:border-r-[4px] before:border-b-white
                    before:border-l-transparent before:border-r-transparent
                    before:content-['']`,
                    // Hover state
                    hoverClass,
                    // Custom positioning and arrow placement
                    tooltipClassName
                )}
            >
                {content}
            </div>
        </>
    );
};
